import type { UploadableFile } from '@/composables/use-file-uploads/types/models/UploadableFile.ts'
import type { MetaFieldsValuesModel } from '@/domains/meta-fields/types/models/MetaFieldsValuesModel.ts'
import type { BrandFormRef } from '@/domains/products/types/models/BrandModel.types.ts'
import type { ProductClassModel } from '@/domains/products/types/models/ProductClassModel.types.ts'
import type { TempVariantModel, VariantModel } from '@/domains/variants/types/models/VariantModel.types.ts'

import { ProductTypeEnum } from '@/domains/products/types/consts/ProductTypeEnum.ts'

interface ExternalData {
  media?: string[]
}

interface ProductModel {
  id?: number
  slug?: string
  title: string
  description: string
  brand_id?: number | null
  brand: BrandFormRef | null
  product_class_id?: number | null
  type: ProductTypeEnum | null
  metas: MetaFieldsValuesModel[]
  taxons: number[]
  variants: VariantModel[]
  media: UploadableFile[]
  is_featured: boolean | null
  external_data: ExternalData | null
  available_sales_channels: string[] | null
  description_html: string | null
  tags: string[] | null
  product_class: ProductClassModel | null
}

interface TempProductModel extends Omit<ProductModel, 'variants'> {
  variants: TempVariantModel[]
}

const DEFAULT_PRODUCT = (): ProductModel => ({
  title: '',
  description: '',
  type: ProductTypeEnum.Variable,
  brand: null,
  metas: [],
  taxons: [],
  variants: [],
  media: [],
  is_featured: null,
  external_data: null,
  available_sales_channels: [],
  description_html: null,
  tags: [],
  product_class_id: null,
  product_class: null
})

export { DEFAULT_PRODUCT }
export type { ProductModel, TempProductModel }
